import { LionReach, LionReturn, LionGuarded, LionHiddenGuard, LionAttachment, LionAttachmentExceptions, LionTakenBack } from './ChuRuleDiagrams';

export function ChuLionDetails() {
  return <div className="chu-details" data-testid="chu-lion-details">
    <h2 className="chu-details-heading">獅子の細かいルール</h2>
    <p className="chu-details-intro">縦・横・斜めに1マスずつ動きます。<br />1回で止めてもかまいません。</p>
    <section data-chu-detail="jump">
      <h3>2マス先へ、1回で跳べます。</h3>
      <figure><LionReach /><figcaption>自分の駒も相手の駒も飛び越せます。<br />跳んだ先に相手の駒があれば、取れます。</figcaption></figure>
    </section>
    <section data-chu-detail="igui">
      <h3>取って戻る「居喰い」</h3>
      <p>隣の相手の駒を取り、<br />2回目に元のマスへ戻れます。</p>
      <figure><LionReturn capture /><figcaption>獅子は元の場所に残り、銀だけが<span className="chu-unbroken">なくなります。</span></figcaption></figure>
    </section>
    <section data-chu-detail="jitto">
      <h3>空きへ行って戻る「じっと」</h3>
      <figure><LionReturn capture={false} /><figcaption>盤面はそのままで、相手の番になります。</figcaption></figure>
      <p>隣に空いたマスがなければ、じっとは<span className="chu-unbroken">できません。</span></p>
    </section>
    <section data-chu-detail="guarded">
      <h3>獅子どうしの取り合い</h3>
      <figure><LionGuarded /><figcaption>隣なら、守られていても取れます。<br />2マス先は守りがないときに取れます。</figcaption></figure>
      <p>相手の獅子を取ったマスに、相手の別の駒が届く場合は「守られている」<span className="chu-unbroken">といいます。</span></p>
      <figure><LionHiddenGuard /><figcaption>自分の獅子が動いて、飛車や角の道が開く場合も<span className="chu-unbroken">含みます。</span></figcaption></figure>
    </section>
    <section data-chu-detail="attachment" className="chu-attachment-detail">
      <h3>2枚取る「付け喰い」</h3>
      <p>先に隣の相手の駒を取り、<br />2回目に守られた獅子を取れます。</p>
      <figure><LionAttachment /><figcaption>銀と獅子を1手で取ります。</figcaption></figure>
      <p>先に取る駒が歩兵・仲人なら、<br />付け喰いはできません。</p>
      <figure><LionAttachmentExceptions /></figure>
      <p>守りがその歩兵・仲人だけでも、その駒と獅子を1手で両方<span className="chu-unbroken">取れません。</span></p>
      <figure><LionAttachmentExceptions soleProtector /></figure>
    </section>
    <section data-chu-detail="double-lion">
      <h3>先に取る駒が獅子でも、付け喰い<span className="chu-unbroken">できます。</span></h3>
      <figure><LionAttachment doubleLion /><figcaption>どちらの獅子も、守られていてかまいません。</figcaption></figure>
      <figure><LionTakenBack /><figcaption>付け喰いの後は相手の駒が届けば獅子を<span className="chu-unbroken">取り返せます。</span></figcaption></figure>
      <p>麒麟が成った獅子にも、同じルールを<span className="chu-unbroken">使います。</span></p>
    </section>
  </div>;
}
